const tableCols = [
    {
        field: 'WN1_ID',
        header: 'ID',
        visible: true,
        filter: true,
        export: {visible: true, checked: true},
        width: 10
    },
    {
        field: 'WN1_VERSION',
        header: 'Version',
        visible: true,
        filter: true,
        export: {visible: true, checked: true},
        width: 30
    },
    {
        field: 'WN1_RELEASE_DATE',
        header: 'Release Date',
        visible: true,
        filter: true,
        export: {visible: true, checked: true},
        width: 30
    },
    {
        field: 'WN1_STATUS',
        header: 'Status',
        visible: true,
        filter: true,
        export: {visible: true, checked: true},
        width: 10
    },
];

export default tableCols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/whatsnew/whatsnew/whatsnew.cols.ts